"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.creator.title': 'Kreator postów',
    'socialMediaPlan.creator.subtitle': 'Brief → Podgląd AI → Planowanie',
    'socialMediaPlan.creator.selectPlatform': 'Wybierz co najmniej jedną platformę',
    'socialMediaPlan.creator.fillBrief': 'Uzupełnij temat i wybierz platformy',
    'socialMediaPlan.creator.aiError': 'Generowanie AI nie powiodło się.',
    'socialMediaPlan.creator.generate.title': 'Wygeneruj treść dopasowaną do każdej platformy',
    'socialMediaPlan.creator.generate.desc': 'Uzupełnij brief w kroku 1, aby wygenerować podgląd AI.',
    'socialMediaPlan.creator.generateBtn': 'Generuj z AI',
    'socialMediaPlan.creator.generating': 'Generuję...',
    'socialMediaPlan.creator.manually': 'Napisz ręcznie (bez AI)',
    'socialMediaPlan.creator.regenerate': 'Generuj ponownie',
    'socialMediaPlan.creator.caption': 'Podpis',
    'socialMediaPlan.creator.imagePrompt': 'Prompt obrazu',
    'socialMediaPlan.creator.imagePromptPlaceholder': 'Opisz obraz do wygenerowania...',
    'socialMediaPlan.creator.generateImage': 'Generuj obraz',
    'socialMediaPlan.creator.imagePromptRequired': 'Najpierw podaj prompt lub temat',
    'socialMediaPlan.creator.videoUpload': 'Plik wideo (YouTube / TikTok)',
    'socialMediaPlan.creator.videoUploadHint': 'Wymagany dla YouTube i TikTok. Wybierz plik wideo do publikacji.',
    'socialMediaPlan.creator.videoChoose': 'Wybierz plik wideo',
    'socialMediaPlan.creator.imageSection': 'Obraz',
    'socialMediaPlan.creator.imagePromptLabel': 'Generuj przez AI',
    'socialMediaPlan.creator.imageUploadLabel': 'Lub wgraj własny obraz',
    'socialMediaPlan.creator.imageChoose': 'Wybierz plik obrazu',
    'socialMediaPlan.creator.imageClear': 'Usuń obraz',
    'socialMediaPlan.creator.videoUploadOnNext': 'Film zostanie przesłany po kliknięciu Dalej.',
    'socialMediaPlan.creator.videoReady': 'Film gotowy do publikacji.',
    'socialMediaPlan.creator.videoError': 'Nie udało się przesłać wideo. Spróbuj ponownie.',
    'socialMediaPlan.creator.imageError': 'Generowanie obrazu nie powiodło się.',
    'socialMediaPlan.creator.tip2026Title': 'Wskazówka trendów 2026',
    'socialMediaPlan.creator.tip2026Text': 'Krótkie, autentyczne treści z jasnym CTA nadal generują najwyższe zaangażowanie. Karuzele i rolki wideo mają obecnie największy zasięg organiczny.',
    'socialMediaPlan.creator.brandName': 'Twoja marka',
    'socialMediaPlan.creator.now': 'teraz',
    'socialMediaPlan.creator.like': 'Lubię to',
    'socialMediaPlan.creator.comment': 'Komentarz',
    'socialMediaPlan.creator.share': 'Udostępnij',
    'socialMediaPlan.creator.fbPageLabel': 'Strona Facebook',
    'socialMediaPlan.creator.fbNoPages': 'Nie znaleziono stron Facebook. Połącz konto w ustawieniach.',
    'socialMediaPlan.creator.liPageLabel': 'Strona LinkedIn',
    'socialMediaPlan.creator.ptBoardLabel': 'Tablica Pinterest',
    'socialMediaPlan.creator.ptNoBoards': 'Nie znaleziono tablic Pinterest. Połącz konto w ustawieniach.',
    'socialMediaPlan.creator.postContent': 'Treść posta',
    'socialMediaPlan.creator.hashtags': 'Hashtagi',
    'socialMediaPlan.creator.hashtagsHint': 'rozdzielone spacją',
    'socialMediaPlan.creator.aiInsightTitle': 'Wskazówka AI',
    'socialMediaPlan.creator.bestTime': 'Najlepsza pora:',
    'socialMediaPlan.creator.charLimit': 'Limit znaków:',
    'socialMediaPlan.creator.videoRemove': 'Usuń wideo',
};
